// extracted by mini-css-extract-plugin
export default {"approveIcon":"StudentCustomTasks_approveIcon__BZJmV","action":"StudentCustomTasks_action__jPuyk"};